export class ProductCard extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.waitingActions = []
  }

  checkValidity () {
    super.checkValidity()

    if (this.els['quick-buy-trigger']?.exists) {
      if (!this.handle) {
        this.throwError('Product card missing data-handle attribute')
      }

      if (!this.url) {
        this.throwError('Product card missing data-url attribute')
      }
    }
  }

  setupListeners () {
    super.setupListeners()

    if (this.els['quick-buy-trigger']?.exists) {
      this.listeners.add(
        this.els['quick-buy-trigger']?.element,
        'mouseenter',
        this.loadQuickBuyDrawer.bind(this),
      )

      this.listeners.add(
        this.els['quick-buy-trigger']?.element,
        'click',
        this.onQuickBuyTriggerClick.bind(this),
      )
    }
  }

  async onQuickBuyTriggerClick (e) {
    if (this.loadingDrawer) {
      this.waiting = true

      this.waitingActions.push(() => {
        window.drawers.activeDrawerKey = this.drawerKey

        this.waiting = false
      })
    }
  }

  async loadQuickBuyDrawer () {
    if (this.drawerExists) return
    if (this.loadingDrawer) return

    this.loadingDrawer = true

    const section = await window.BAO.sectionRenderer.fetchSingle(
      'product-quick-buy-drawer',
      this.url,
    )
    if (!section) {
      // TODO: Render error

      return
    }

    const dom = window.BAO.sectionRenderer.convertToDOM(section)
    const drawer = dom.querySelector('site-drawer')
    const drawerReviewWidget = drawer.querySelector(
      '.yotpo-widget-instance.prd-Card_Yotpo',
    )
    let reviewWidgetInstanceId = ''
    if (drawerReviewWidget) {
      reviewWidgetInstanceId = drawerReviewWidget.dataset.yotpoInstanceId || ''
    }

    if (!drawer) {
      // TODO: Render error

      return
    }

    const drawers = document.querySelector('site-drawers')
    drawers.insertAdjacentElement('afterbegin', drawer)

    this.els[
      'quick-buy-trigger'
    ].element.dataset.drawersTrigger = this.drawerKey

    this.loadingDrawer = false

    const atcButtonColour =
      this.els['quick-buy-trigger']?.element.dataset.collectionAtcButton ||
      'default'

    if (atcButtonColour !== 'default') {
      const addToCartButton = document.querySelector(
        '[data-product-add-to-cart]',
      )

      if (addToCartButton) {
        addToCartButton.classList.add(`btn-Button-${atcButtonColour}`)
      }
    }

    if (this.waitingActions.length > 0) {
      for (const waitingAction of this.waitingActions) {
        await waitingAction()
      }
    }

    // eslint-disable-next-line no-undef
    // yotpo?.initWidgets()
    if (reviewWidgetInstanceId !== '') {
      // eslint-disable-next-line no-undef
      yotpoWidgetsContainer.initWidget(
        reviewWidgetInstanceId,
        drawerReviewWidget,
      )
    }
  }

  get drawerExists () {
    return document.querySelector(`site-drawer[key="${this.drawerKey}"]`)
  }

  get drawerKey () {
    return `quick-buy-drawer-${this.handle}`
  }

  get loadingDrawer () {
    return this.dataset.loadingDrawer === 'true'
  }

  set loadingDrawer (val) {
    this.dataset.loadingDrawer = val.toString()
  }

  get waiting () {
    return this.dataset.waiting === 'true'
  }

  set waiting (val) {
    this.dataset.waiting = val.toString()
  }

  get handle () {
    return this.dataset.handle
  }

  get url () {
    return this.dataset.url
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard)
}
